// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `iframe#webpack-dev-server-client-overlay {
  display: none;
}

.tripleR-navigation-box {
  width: 100px;
}

.tripleR-body-box {
  justify-content: center;
  font-weight: 700;
}




/* Below is styling for nav hamburger (mobile) */

.w-nav-button {
  float: right;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  /* -webkit-text-fill-color: transparent; */
  -webkit-user-select: none;
  user-select: none;
  /* padding: 18px; */
  /* font-size: 24px; */
  display: none;
  /* position: relative; */
}

.w-nav-button:focus {
  outline: 0;
}

.w-nav-button.w--open {
  color: none;
  background-color: none;
}

.w-nav[data-collapse="all"] .w-nav-button,
.w--nav-dropdown-open,
.w--nav-dropdown-toggle-open {
  display: block;
}

@media screen and (max-width: 991px) {
  .w-nav[data-collapse="medium"] .w-nav-menu {
    display: none;
  }

  .w-nav[data-collapse="medium"] .w-nav-button {
    display: block;
  }
}

@media screen and (max-width: 767px) {
  .w-nav[data-collapse="small"] .w-nav-menu {
    display: none;
  }

  .w-nav[data-collapse="small"] .w-nav-button {
    display: block;
  }

  .w-nav-brand {
    padding-left: 10px;
  }
}

@media screen and (max-width: 479px) {
  .w-nav[data-collapse="tiny"] .w-nav-menu {
    display: none;
  }

  .w-nav[data-collapse="tiny"] .w-nav-button {
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;;;;AAKA,gDAAgD;;AAEhD;EACE,YAAY;EACZ,eAAe;EACf,wCAAwC;EACxC,0CAA0C;EAC1C,yBAAyB;EAEzB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["iframe#webpack-dev-server-client-overlay {\n  display: none;\n}\n\n.tripleR-navigation-box {\n  width: 100px;\n}\n\n.tripleR-body-box {\n  justify-content: center;\n  font-weight: 700;\n}\n\n\n\n\n/* Below is styling for nav hamburger (mobile) */\n\n.w-nav-button {\n  float: right;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  /* -webkit-text-fill-color: transparent; */\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  /* padding: 18px; */\n  /* font-size: 24px; */\n  display: none;\n  /* position: relative; */\n}\n\n.w-nav-button:focus {\n  outline: 0;\n}\n\n.w-nav-button.w--open {\n  color: none;\n  background-color: none;\n}\n\n.w-nav[data-collapse=\"all\"] .w-nav-button,\n.w--nav-dropdown-open,\n.w--nav-dropdown-toggle-open {\n  display: block;\n}\n\n@media screen and (max-width: 991px) {\n  .w-nav[data-collapse=\"medium\"] .w-nav-menu {\n    display: none;\n  }\n\n  .w-nav[data-collapse=\"medium\"] .w-nav-button {\n    display: block;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .w-nav[data-collapse=\"small\"] .w-nav-menu {\n    display: none;\n  }\n\n  .w-nav[data-collapse=\"small\"] .w-nav-button {\n    display: block;\n  }\n\n  .w-nav-brand {\n    padding-left: 10px;\n  }\n}\n\n@media screen and (max-width: 479px) {\n  .w-nav[data-collapse=\"tiny\"] .w-nav-menu {\n    display: none;\n  }\n\n  .w-nav[data-collapse=\"tiny\"] .w-nav-button {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
